/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_P1tInputs */

const en_mk_sol_agensi_p1t = /** @type {(inputs: Mk_Sol_Agensi_P1tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Briefs disappear up the chat scroll`)
};

const id_mk_sol_agensi_p1t = /** @type {(inputs: Mk_Sol_Agensi_P1tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brief hilang di gulungan chat`)
};

/**
* | output |
* | --- |
* | "Briefs disappear up the chat scroll" |
*
* @param {Mk_Sol_Agensi_P1tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_p1t = /** @type {((inputs?: Mk_Sol_Agensi_P1tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_P1tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_p1t(inputs)
	return en_mk_sol_agensi_p1t(inputs)
});